module.exports = __webpack_public_path__ + "img/start_exam.d89816cc.png";